module.exports = __webpack_public_path__ + "static/media/portfolio7-7.740d7fd9.png";